/* DEFAULT (TENANT/GLOBAL) SCORING CONFIG (FIN-12215) */
export const FETCH_DEFAULT_SCORING_CONFIG = 'FETCH_DEFAULT_SCORING_CONFIG';
export const FETCH_DEFAULT_SCORING_CONFIG_SUCCESS =
  'FETCH_DEFAULT_SCORING_CONFIG_SUCCESS';
export const FETCH_DEFAULT_SCORING_CONFIG_FAIL =
  'FETCH_DEFAULT_SCORING_CONFIG_FAIL';

export const SAVE_DEFAULT_SCORING_CONFIG = 'SAVE_DEFAULT_SCORING_CONFIG';
export const SAVE_DEFAULT_SCORING_CONFIG_SUCCESS =
  'SAVE_DEFAULT_SCORING_CONFIG_SUCCESS';
export const SAVE_DEFAULT_SCORING_CONFIG_FAIL =
  'SAVE_DEFAULT_SCORING_CONFIG_FAIL';

export const DEFAULT_SCORING_CONFIG_CLEAR = 'DEFAULT_SCORING_CONFIG_CLEAR';

export const fetchDefaultScoringConfig = (payload) => ({
  type: FETCH_DEFAULT_SCORING_CONFIG,
  payload
});
export const fetchDefaultScoringConfigSuccess = (payload) => ({
  type: FETCH_DEFAULT_SCORING_CONFIG_SUCCESS,
  payload
});
export const fetchDefaultScoringConfigFail = (payload) => ({
  type: FETCH_DEFAULT_SCORING_CONFIG_FAIL,
  payload
});

export const saveDefaultScoringConfig = (payload) => ({
  type: SAVE_DEFAULT_SCORING_CONFIG,
  payload
});
export const saveDefaultScoringConfigSuccess = (payload) => ({
  type: SAVE_DEFAULT_SCORING_CONFIG_SUCCESS,
  payload
});
export const saveDefaultScoringConfigFail = (payload) => ({
  type: SAVE_DEFAULT_SCORING_CONFIG_FAIL,
  payload
});

export const defaultScoringConfigClear = () => ({
  type: DEFAULT_SCORING_CONFIG_CLEAR
});
